export const games = [
  {
    id: 1,
    name: '豪华百家乐',
    category: 'live',
    categoryName: '真人娱乐',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20casino%20baccarat%20table%20with%20gold%20accents%20and%20green%20felt%2C%20professional%20dealer%2C%20warm%20dramatic%20lighting%2C%20dark%20background%2C%20premium%20gaming%20atmosphere%2C%20rich%20textures%2C%20editorial%20photography%20style%2C%20no%20people%20faces%20visible&width=800&height=600&seq=game-baccarat-01&orientation=landscape',
    rating: 4.9,
    players: 12800,
    tags: ['热门', '高赔率'],
  },
  {
    id: 2,
    name: '龙虎斗',
    category: 'live',
    categoryName: '真人娱乐',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20dragon%20tiger%20casino%20gaming%20table%20with%20golden%20decorations%2C%20red%20and%20gold%20theme%2C%20professional%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20dark%20elegant%20background%2C%20premium%20interior%2C%20editorial%20photography&width=800&height=600&seq=game-dragon-tiger-02&orientation=landscape',
    rating: 4.8,
    players: 9600,
    tags: ['新上线', '高赔率'],
  },
  {
    id: 3,
    name: '轮盘',
    category: 'live',
    categoryName: '真人娱乐',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20casino%20roulette%20wheel%20with%20gold%20and%20dark%20wood%20accents%2C%20green%20felt%20table%2C%20luxury%20gaming%20environment%2C%20warm%20ambient%20lighting%2C%20dark%20sophisticated%20background%2C%20premium%20interior%20design%2C%20editorial%20photography&width=800&height=600&seq=game-roulette-03&orientation=landscape',
    rating: 4.7,
    players: 8500,
    tags: ['经典'],
  },
  {
    id: 4,
    name: '财神到',
    category: 'slot',
    categoryName: '老虎机',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20wealth%20god%20themed%20slot%20machine%20with%20gold%20coins%20and%20red%20lanterns%2C%20luxurious%20golden%20frame%2C%20dark%20background%20with%20sparkles%2C%20premium%20gaming%20display%2C%20rich%20colors%2C%20elegant%20presentation&width=800&height=600&seq=game-slot-wealth-04&orientation=landscape',
    rating: 4.9,
    players: 25600,
    tags: ['热门', '高奖金'],
  },
  {
    id: 5,
    name: '金狮王',
    category: 'slot',
    categoryName: '老虎机',
    image: 'https://readdy.ai/api/search-image?query=Golden%20lion%20themed%20slot%20machine%20display%20with%20majestic%20golden%20lion%20statue%2C%20rich%20red%20and%20gold%20colors%2C%20dark%20luxurious%20background%2C%20sparkling%20effects%2C%20premium%20gaming%20aesthetic%2C%20elegant%20presentation&width=800&height=600&seq=game-slot-lion-05&orientation=landscape',
    rating: 4.8,
    players: 19800,
    tags: ['热门', '累积奖池'],
  },
  {
    id: 6,
    name: '龙王宝藏',
    category: 'slot',
    categoryName: '老虎机',
    image: 'https://readdy.ai/api/search-image?query=Mythical%20dragon%20treasure%20themed%20slot%20machine%20with%20gold%20and%20jade%20accents%2C%20dark%20mysterious%20background%2C%20glowing%20treasure%20chest%2C%20luxurious%20gaming%20display%2C%20rich%20oriental%20aesthetic%2C%20premium%20presentation&width=800&height=600&seq=game-slot-dragon-06&orientation=landscape',
    rating: 4.7,
    players: 15200,
    tags: ['新上线'],
  },
  {
    id: 7,
    name: '足球竞猜',
    category: 'sports',
    categoryName: '体育竞猜',
    image: 'https://readdy.ai/api/search-image?query=Football%20stadium%20at%20night%20with%20dramatic%20lighting%2C%20golden%20accents%2C%20sports%20betting%20theme%2C%20dark%20sophisticated%20background%2C%20dynamic%20atmosphere%2C%20premium%20sports%20aesthetic%2C%20editorial%20photography&width=800&height=600&seq=game-football-07&orientation=landscape',
    rating: 4.9,
    players: 32000,
    tags: ['热门', '实时'],
  },
  {
    id: 8,
    name: '篮球竞猜',
    category: 'sports',
    categoryName: '体育竞猜',
    image: 'https://readdy.ai/api/search-image?query=Basketball%20arena%20with%20dramatic%20spotlight%2C%20golden%20accents%2C%20sports%20betting%20theme%2C%20dark%20atmosphere%2C%20dynamic%20energy%2C%20premium%20sports%20presentation%2C%20editorial%20photography%20style&width=800&height=600&seq=game-basketball-08&orientation=landscape',
    rating: 4.8,
    players: 24500,
    tags: ['热门', '实时'],
  },
  {
    id: 9,
    name: '快乐8',
    category: 'lottery',
    categoryName: '彩票',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20lottery%20balls%20with%20golden%20numbers%2C%20dark%20elegant%20background%20with%20gold%20sparkles%2C%20premium%20gaming%20presentation%2C%20rich%20red%20and%20gold%20color%20scheme%2C%20sophisticated%20design&width=800&height=600&seq=game-lottery-09&orientation=landscape',
    rating: 4.7,
    players: 18200,
    tags: ['高频率'],
  },
  {
    id: 10,
    name: '斗地主',
    category: 'card',
    categoryName: '棋牌',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20playing%20cards%20on%20dark%20luxurious%20table%20with%20golden%20decorations%2C%20warm%20ambient%20lighting%2C%20premium%20gaming%20atmosphere%2C%20rich%20textures%2C%20sophisticated%20presentation%2C%20editorial%20photography&width=800&height=600&seq=game-card-10&orientation=landscape',
    rating: 4.8,
    players: 22000,
    tags: ['经典', '多人'],
  },
  {
    id: 11,
    name: '骰宝',
    category: 'live',
    categoryName: '真人娱乐',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20casino%20dice%20game%20table%20with%20golden%20accents%2C%20dark%20wood%20surface%2C%20warm%20dramatic%20lighting%2C%20elegant%20atmosphere%2C%20premium%20gaming%20environment%2C%20editorial%20photography%20style&width=800&height=600&seq=game-sicbo-11&orientation=landscape',
    rating: 4.6,
    players: 7800,
    tags: ['经典'],
  },
  {
    id: 12,
    name: '炸金花',
    category: 'card',
    categoryName: '棋牌',
    image: 'https://readdy.ai/api/search-image?query=Golden%20playing%20cards%20spread%20on%20dark%20velvet%20table%2C%20luxurious%20gaming%20atmosphere%2C%20warm%20golden%20lighting%2C%20rich%20textures%2C%20premium%20presentation%2C%20elegant%20oriental%20style&width=800&height=600&seq=game-card-golden-12&orientation=landscape',
    rating: 4.7,
    players: 16500,
    tags: ['热门', '多人'],
  },
];

export const categories = [
  { key: 'all', name: '全部', icon: 'ri-apps-line' },
  { key: 'live', name: '真人娱乐', icon: 'ri-live-line' },
  { key: 'slot', name: '老虎机', icon: 'ri-gamepad-line' },
  { key: 'sports', name: '体育竞猜', icon: 'ri-football-line' },
  { key: 'lottery', name: '彩票', icon: 'ri-numbers-line' },
  { key: 'card', name: '棋牌', icon: 'ri-gamepad-line' },
];